import { render, staticRenderFns } from "./CustomOverlaysAreaPicker.vue?vue&type=template&id=5f8b01b5&"
import script from "./CustomOverlaysAreaPicker.vue?vue&type=script&lang=js&"
export * from "./CustomOverlaysAreaPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports